export const EXPANSION_COVERAGE_ERROR_CODE = 'CASR1'

export function expansionCoverageGapFromError (error) {
  const data = error?.response?.data
  return data?.code === EXPANSION_COVERAGE_ERROR_CODE ? data.details : null
}
